
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CPAccountSummaryOutOfDate extends Vue {
  
  get formattedMessage(): string {
    const message = this.$store.state.accountSummaryOutOfDate;
    if (!message) return '';
    
    // Convert any dates in the message to DD/MM/YYYY format
    // Matches formats like: DD-MM-YYYY, DD/MM/YYYY, YYYY-MM-DD, MM-DD-YYYY, MM/DD/YYYY
    return message.replace(
      /(\d{1,2})[-/](\d{1,2})[-/](\d{4})|(\d{4})[-/](\d{1,2})[-/](\d{1,2})/g,
      (match: string, d1?: string, m1?: string, y1?: string, y2?: string, m2?: string, d2?: string) => {
        if (y1 && d1 && m1) {
          // Format: DD-MM-YYYY or MM-DD-YYYY
          const day = d1.padStart(2, '0');
          const month = m1.padStart(2, '0');
          return `${day}/${month}/${y1}`;
        } else if (y2 && m2 && d2) {
          // Format: YYYY-MM-DD
          const day = d2.padStart(2, '0');
          const month = m2.padStart(2, '0');
          return `${day}/${month}/${y2}`;
        }
        return match;
      }
    );
  }
}
